import { request } from 'utils/requests'

export async function sendAiMessage(message, history = [], { mode, processId } = {}) {
  const { data } = await request.post('/ai/chat', { message, history, mode, processId })
  return data
}

// Resumo e próximos passos do processo (nossa IA; o salvo é lido sem custo)
export const getProcessBriefing = async (processId) => (await request.get(`/ai/processos/${processId}/resumo`)).data
export const generateProcessBriefing = async (processId) => (await request.post(`/ai/processos/${processId}/resumo`)).data

// A assistente está ligada no servidor? (Gemini/Groq/OpenAI configurado)
let statusPromise = null
export const getAiStatus = () => {
  if (!statusPromise) {
    statusPromise = request.get('/ai/status').then(({ data }) => data).catch(() => { statusPromise = null; return { ativa: false } })
  }
  return statusPromise
}

// Chat da Sofia: escolher processo e cartão do processo
export const buscarProcessosIa = async (q) => (await request.get('/ai/processos', { params: { q } })).data
export const getPainelProcesso = async (id) => (await request.get(`/ai/processos/${id}/painel`)).data
